import React from 'react';
import { CheckIcon, UsersIcon, ClockIcon } from 'lucide-react';
interface RideCardProps {
  type: string;
  price: number;
  currency: 'RM' | 'SGD';
  duration: string;
  seats: number;
  selected?: boolean;
  onClick: () => void;
}
export const RideCard: React.FC<RideCardProps> = ({
  type,
  price,
  currency,
  duration,
  seats,
  selected = false,
  onClick
}) => {
  return <div className={`card mb-3 ${selected ? 'border-primary border-opacity-100' : ''} transition-all`} onClick={onClick} data-id="element-122">
      <div className="flex justify-between items-center" data-id="element-123">
        <div data-id="element-124">
          <h3 className="text-lg font-semibold" data-id="element-125">{type}</h3>
          <div className="flex items-center text-white text-opacity-70 mt-1" data-id="element-126">
            <ClockIcon size={16} className="mr-1" data-id="element-127" />
            <span className="text-sm mr-3" data-id="element-128">{duration}</span>
            <UsersIcon size={16} className="mr-1" data-id="element-129" />
            <span className="text-sm" data-id="element-130">{seats} seats</span>
          </div>
          <p className="text-xs text-white text-opacity-70 mt-1" data-id="element-131">
            Cross-border fee included
          </p>
        </div>
        <div className="flex flex-col items-end" data-id="element-132">
          <div className="chip mb-2" data-id="element-133">
            {currency} {price}
          </div>
          {selected && <div className="bg-primary rounded-full p-1" data-id="element-134">
              <CheckIcon size={16} className="text-background" data-id="element-135" />
            </div>}
        </div>
      </div>
    </div>;
};